import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Box, Card, CardContent, Button, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { agenticUseCases } from '../../../data/agenticUseCases';
import './AgenticAI.scss';

const AgenticAI = () => {
  return (
    <section id="agentic-ai" className="agentic-section">
      <Container maxWidth="lg">
        <Typography variant="h2" className="section-title" gutterBottom>
          Agentic AI
        </Typography>
        <Box className="section-divider" />
        <Box className="agentic-banner">
          <Typography variant="overline" className="agentic-banner-kicker">
            Agentic AI · Use cases · Architecture
          </Typography>
          <Typography variant="h3" component="h3" className="agentic-banner-title">
            More use cases will live here
          </Typography>
          <Typography variant="body1" className="agentic-banner-copy">
            This is a catalog of agentic architectures, starting with the first write-up below.
            Each new pattern — orchestration, evals, human-in-the-loop, multi-agent handoff —
            gets its own article in this tab.
          </Typography>
        </Box>
        <Box className="agentic-grid">
          {agenticUseCases.map((item) => {
            const isPublished = item.status === 'published';
            return (
              <Card key={item.slug} className="agentic-card" elevation={2}>
                <CardContent className="agentic-card-content">
                  <Box className="agentic-card-tags">
                    {item.tags.map((tag) => (
                      <Chip key={tag} label={tag} size="small" className="agentic-tag" />
                    ))}
                  </Box>
                  <Typography variant="h6" component="h3" className="agentic-card-title">
                    {item.title}
                  </Typography>
                  <Typography variant="body2" className="agentic-card-excerpt" color="text.secondary">
                    {item.excerpt}
                  </Typography>
                  <Box className="agentic-card-footer">
                    <Typography variant="caption" className="agentic-read-time">
                      {item.readTime}
                    </Typography>
                    {isPublished ? (
                      <Button
                        component={Link}
                        to={`/agentic/${item.slug}`}
                        endIcon={<ArrowForwardIcon />}
                        size="small"
                        className="agentic-read-more"
                      >
                        Read architecture
                      </Button>
                    ) : (
                      <Typography variant="caption" className="agentic-coming-soon">
                        Coming soon
                      </Typography>
                    )}
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Box>
      </Container>
    </section>
  );
};

export default AgenticAI;
